import { B2B_GETTZAP_HOST } from "../consts/api.ts";
import { defaultHeaders } from "./utils.ts";

const WHITE_LIST_API = "/b2b/api/direct/prices";

export interface IAddPriceData {
  uid: string;
  replica: boolean;
  cost: number;
  minBatch: number;
  sellerId: number;
  note: string;
}

export const addPriceApi = (data: IAddPriceData) => {
  return fetch(`${B2B_GETTZAP_HOST}${WHITE_LIST_API}`, {
    method: "POST",
    headers: defaultHeaders,
    body: JSON.stringify(data),
  });
};

export const getPricesApi = (params = {}) => {
  const queryParams = "?" + new URLSearchParams(params);

  return fetch(`${B2B_GETTZAP_HOST}/b2b/api/direct/prices/list` + queryParams, {
    method: "GET",
    headers: defaultHeaders,
  });
}